import { withAuth } from '@postinumero/react-auth';
import useAxiosAuthHeaderUpdater from './useAxiosAuthHeaderUpdater';
import { useKeycloak } from '@react-keycloak/web';

export default withAuth(function Auth({ children }) {
  useAxiosAuthHeaderUpdater(useKeycloak().keycloak.token);
  return children;
});
